import * as selectors from "./selectors";
import userSlice from "./slice";

export const UserActions = { ...userSlice.actions };
export const UserReducer = userSlice.reducer;
export const UserSelectors = selectors;
